import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router";

import { setCardDetail, setInviteId } from "@redux";
import { PATH_CARD, PATH_WELCOME } from "@configs";

export const PageAddCard = () => {
    const { id } = useParams<{ id: string }>();

    const dispatch = useDispatch();
    const history = useHistory();
    // useEffect(() => {
    //     if (id) {
    //         // set traffice source to store, inorder to use that id on header call
    //         // dispatch(setInviteId(id));
    //         // history.push(PATH_WELCOME);
    //     }
    // }, [id]);
    useEffect(() => {
        let queryParams = new URLSearchParams(window.location.search);

        let snum = queryParams.get("snum") || "";
        let cnum = queryParams.get("cnum") || "";
        dispatch(setCardDetail({
            sNum: snum,
            cNum: cnum,
        }));

        history.push(PATH_CARD);

    }, []);
    return <></>;
};
